<span *ngIf="state?.isPromo" class="promo">{{ this.translations.promo | translate }}</span>

<ng-container *ngFor="let rubric of state.rubrics; let i = index; trackBy: trackByFn">
  <alliance-clubs-rubrics-item class="santa-truncate santa-flex" [rubric]="rubric"></alliance-clubs-rubrics-item>
</ng-container>
